import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

import { useProduct } from '@/screens/Product/hooks/useProduct'
import { adaptProperties } from '@/screens/Product/model/common/adaptProperties'
import { getIsShowRustoreBlock } from '@/screens/Product/model/common/getIsShowRustoreBlock'

import { GiftsWithProduct } from '@/features/cart/gift'
import { PromotionWithProduct } from '@/features/cart/promotion'
import { useProductCurrentReviewSummary } from '@/features/product-reviews'

import { ProductRating } from '@/entities/card/ui/product-rating/ProductRating'

import { OrderType } from '@/shared/types/product-types'

import { LimitedBox } from '../limited-box/LimitedBox'
import { ProductGuarantee } from '../product-guarantee/ProductGuarantee'
import { ProductSpecsPanel } from '../product-specs-panel/ProductSpecsPanel'
import { ProductVariants } from '../product-variants'

import cl from './product-parameters.module.scss'

export const ProductParameters = () => {
	const { product, crossLinks, isCrossLinksLoading } = useProduct()
	const { summary: reviewsSummary, isLoading: isReviewsSummaryLoading } = useProductCurrentReviewSummary(
		product,
		crossLinks,
		isCrossLinksLoading
	)
	const categoriesItems = useSelector(selectors.categoriesItems)
	const productSection = categoriesItems.find(({ id }) => product.SECTION_ID.toString() === id)
	const showGift = product.ORDER_TYPE !== OrderType.Archive && product.ORDER_TYPE !== OrderType.HideBuy
	const showRustoreBlock = getIsShowRustoreBlock(productSection?.code, product.KOD)
	const { ID, KOD } = product
	const productProperties = [{ name: `Код товара`, value: KOD }, ...adaptProperties(product.PROPERTIES)]

	return (
		<div className={cl.stickyPannel}>
			<div className={cl.subInfoPanel}>
				{showRustoreBlock && <ProductGuarantee className={cl.subInfoPanelItem} />}
				{!!product?.INFO && <LimitedBox className={cl.subInfoPanelItem} />}
				{showGift && <GiftsWithProduct className={cl.subInfoPanelItem} productId={ID} />}
				{showGift && <PromotionWithProduct className={cl.subInfoPanelItem} product={product} />}
			</div>
			<ProductRating
				className={cl.reviewsRating}
				summary={reviewsSummary}
				productCode={product.KOD}
				isMobileCompact={false}
				disableNavigation
				showAverage={false}
				showEmptyReviewsText={!isReviewsSummaryLoading}
				showEmptyReviewsStars
				underlineReviewsText
			/>
			{!!crossLinks && <ProductVariants crossLinks={crossLinks} />}
			{!!product.PROPERTIES && <ProductSpecsPanel items={productProperties} />}
		</div>
	)
}
